const commonSampleFilePath =
  "http://localhost:3000/images/sample";

const configSampleFiles = {
  "employees": "http://api.hospitaladmin.dosystemsinc.com/images/sample_employee_bulk_upload_file.csv",
  "Activitiess": "http://api.hospitaladmin.dosystemsinc.com/images/sample_Activities_bulk_upload_file.csv",
  "Email Templatess": "http://api.hospitaladmin.dosystemsinc.com/images/sample_Email Templates_bulk_upload_file.csv",
  "Roless": "http://api.hospitaladmin.dosystemsinc.com/images/sample_Roles_bulk_upload_file.csv",
  "Upload Historys": "http://api.hospitaladmin.dosystemsinc.com/images/sample_Upload History_bulk_upload_file.csv",
  "Email Statuss": "http://api.hospitaladmin.dosystemsinc.com/images/sample_Email Status_bulk_upload_file.csv",
  "hospitalemployees": "http://api.hospitaladmin.dosystemsinc.com/images/sample_hospitalemployee_bulk_upload_file.csv",
  "facilityemployees": "http://api.hospitaladmin.dosystemsinc.com/images/sample_facilityemployee_bulk_upload_file.csv",
  "providerss": "http://api.hospitaladmin.dosystemsinc.com/images/sample_providers_bulk_upload_file.csv",
  "facilitiess": "http://api.hospitaladmin.dosystemsinc.com/images/sample_facilities_bulk_upload_file.csv",
  "patientss": "http://api.hospitaladmin.dosystemsinc.com/images/sample_patients_bulk_upload_file.csv",
  "orderss": "http://api.hospitaladmin.dosystemsinc.com/images/sample_orders_bulk_upload_file.csv",
  "Slotss": "http://api.hospitaladmin.dosystemsinc.com/images/sample_slots_bulk_upload_file.csv",
  "Appointmentss": "http://api.hospitaladmin.dosystemsinc.com/images/sample_appointmentss_bulk_upload_file.csv",
};
export default configSampleFiles;